<template>
<div>
    <div v-for="(resource, index) in resources.resources" :key="`resource-${index}`">
      <ResourceListItem
        :id="resource.id"
        :title="resource.title"
        :image="resource.thumb"
      ></ResourceListItem>
    </div>
    <Pagination :current="resources.pagination.current_page" :total="total" @onPageChanged="toPage" v-if="total > 1"></Pagination>
  </div>
</template>

<script>
import Button from '@/components/Button'
import ResourceListItem from '@/components/ManualResourceListItem'
import Pagination from '@/components/Pagination'
import ManualService from '@/services/ManualService'

export default {
  components: {
    Button,
    Pagination,
    ResourceListItem
  },
  data () {
    return {
      resources: this.content
    }
  },
  watch: {
    content: function (val) {
      this.resources = val
    }
  },
  computed: {
    total: function () {
      return Math.ceil(this.resources.pagination.total / 10)
    }
  },
  methods: {
    toPage (page) {
      if (page > 0 && page <= this.total) {
        ManualService.getResources({ types: [this.$route.params.unit], page: page })
          .then((resources) => {
            this.resources = resources
          })
      }
    }
  },
  props: {
    content: {
      type: Object,
      required: true
    },
    selected: {
      default: null
    }
  }
}
</script>

<style lang="scss">

@import '~styles/base/variables';
@import '~styles/base/mixins';

</style>



// WEBPACK FOOTER //
// src/components/ManualResourceContent.vue